import { fetchWithAuth } from './utils';

export async function editUser(email, values) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/users/edit`);
    url.searchParams.append('email', email);

    const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}


export async function getUserByEmail(email) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/users/edit`);
    url.searchParams.append('email', email);

    const response = await fetchWithAuth(url);

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function createUser(data) {
    const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/users/create-user`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}

export async function getUserList() {
  try {
    const url = new URL(`${process.env.REACT_APP_API_URL}/users/list`);

    const response = await fetchWithAuth(url);
    const text = await response.text();
    const data = JSON.parse(text);

    return data;
  } catch (error) {
    console.error("Error fetching user list:", error);
    throw error;
  }
};

export async function deleteUserByEmail(email) {
  try {
    const url = new URL(`${process.env.REACT_APP_API_URL}/users/delete`);
    url.searchParams.append("email", email);

    const response = await fetchWithAuth(url, {
      method: "POST",
    });

    if (!response.ok) {
      throw new Error("Failed to delete the user");
    }

    return true;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};